import React from 'react';
import { formatDate, dashBoardformatDate } from '../../../utils';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { appTheme } from '../../../helpers/utils/Utils';

const UpcomingTransactionItem = ({ transactionData ,cancelUpcomingTransaction}) => {
  const { t } = useTranslation();
  const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
  const appThemeData = appTheme(kudzuPlusTrue);
    const { IconUri, Description, TransactionDate, TransactionType, Category, StartDate, ExternalStatus, Amount, DrCrIndicator,TransactionId, StatusCode} = transactionData;
  const isDefaultStartDate = !StartDate ||
    StartDate === "---" ||
    StartDate === "Not Specified" ||
    StartDate?.startsWith("9999");
  const formattedDate = dashBoardformatDate(StartDate);

  const date = isDefaultStartDate ? "---" : formattedDate;
  // const StatusCode='APP';
  const isPending = StatusCode === 'APP';
  const externalText =  StatusCode === 'APP' ? 'Pending' : '';
  const isCredit = DrCrIndicator === "Cr" ? true : false;
  const textColor = DrCrIndicator === "Cr" ? "text-kudzu-text" : "text-secondary-3";
  const prefix = DrCrIndicator === "Cr" ? "+ " : "- ";
  //{`${isPending ? 'italic text-secondary-3 opacity-50' : 'text-secondary-3'}`}

  const styleAll = `font-[400] my-auto font-hanken-grotesk md:text-[16px] sm:text-[11px] text-[16px]`;
  const styleStatus = `font-[400] my-auto font-hanken-grotesk md:text-[16px] sm:text-[11px] text-[16px]`;
  const styleAmount = `font-[600] my-auto font-hanken-grotesk text-[18px]`;
  
  return (    

    <tr className='cursor-pointer' onClick={()=>{cancelUpcomingTransaction(transactionData)}}>
          <td width="60" className='py-5 pr-[.5rem]'>
              <span className="transactionCategoryIcon">  <img src={IconUri} alt={t('transaction_category_icon', { category: Category || 'Transaction' })} className='h-[14px]' /></span>
          </td>
      <td className={`py-5 text-left font-[500] lg:max-w-[22rem] md:max-w-[22rem] sm:max-w-[6rem]
       max-w-[11rem] break-words  ${styleAll} 
       ${!isPending ? 'text-[var(--text-clr-transactions)]' : 'text-[var(--text-clr-transactions-inactive)]'}`}>
        {Description}
        <p className={`
        sm:hidden block text-[13px] font-hanken-grotesk font-[400] mt-[0.3rem]`}>
         <span className={`${isPending ? 'text-[var(--text-clr-transactions)]' : 'text-[var(--text-clr-transactions-inactive)]'} w-[80px] inline-block`}> {date}</span>
          <span className='text-[var(--text-clr-transactions-cancel)] ml-2 cursor-pointer' onClick={()=>{cancelUpcomingTransaction(transactionData)}}>{t('cancel')}</span>
        </p>
      </td>
          <td className={`py-5 text-left font-light text-base leading-none tracking-normal hidden sm:table-cell ${styleAll}
      text-[var(--text-clr-transactions)]`}>{Category}</td>

      <td className={`py-5 text-left font-[500] hidden sm:table-cell ${styleAll}
      ${!isPending ? 'text-[var(--text-clr-transactions)]' : 'text-[var(--text-clr-transactions-inactive)]'}`}>{date}</td>

      <td className={`py-5 text-left hidden sm:table-cell ${styleStatus}`}>
        {/* {externalText} */}
        {/* //${isPending ? 'text-[#262B3A] opacity-[50%]' : isCredit ? 'text-kudzu-text' : 'text-[#262B3A]'} */}
        {/* <p className={`sm:block hidden text-[var(--text-clr-transactions-cancel)] md:text-[18px] sm:text-[11px] text-[16px] font-hanken-grotesk font-[400] cursor-pointer`} 
        onClick={()=>{cancelUpcomingTransaction(transactionData)}}>{t('cancel')}</p> */}

      </td>
      

      <td className={` sm:table-cell  flex justify-end py-5 text-right font-[500] whitespace-nowrap ${styleAmount} ${isPending ? 'text-[var(--text-clr-transactions-inactive)]' : isCredit ? 'text-[var(--text-clr-transactions-credit)]' : 'text-[var(--text-clr-transactions)]'} `}>       
        {parseInt(Amount)}
        .{(Amount % 1).toFixed(2).slice(2)}
        <p className={`${isPending ? 'text-[var(--text-clr-transactions)]' : isCredit ? 'text-[var(--text-clr-transactions-credit)]' : 'text-[var(--text-clr-transactions)]'}
        italic text-[13px] font-[400] sm:hidden block`}> {externalText}</p>
      </td>

      <td className='py-5 pl-4'>
        <img src={appThemeData.ArrowsIconToSee} alt="View details" className='w-[8px] h-[12px] opacity-60' />
      </td>
    </tr>
  );
};



export default UpcomingTransactionItem;
